<template>
  <div class="graphic panel-settings">
    <div
      v-if="panel.settings && panel.settings.animations && panel.settings.animations.length"
      class="tb-form-group"
    >
      <hot-keys
        :item="item"
        :editing="editing"
        :panel="panel"
        :production_context="production_context"
      />
    </div>

    <div v-else class="empty-state-text">This panel does not have any editable settings at this time.</div>
  </div>
</template>

<script>
export default {
  props: ['panel', 'editing', 'item', 'production_context'],

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
};
</script>
